import { render, staticRenderFns } from "./Hzzw.vue?vue&type=template&id=ebd19ca2&scoped=true&"
import script from "./Hzzw.vue?vue&type=script&lang=js&"
export * from "./Hzzw.vue?vue&type=script&lang=js&"
import style0 from "./Hzzw.vue?vue&type=style&index=0&id=ebd19ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd19ca2",
  null
  
)

export default component.exports